import { TValidator } from "../../../../../wizard/types";

const addMajorValidator: TValidator = async ({ values }) => {
  const errors: { [key: string]: any } = {};

  if (!values.name?.trim()) {
    errors.name = "Major name is required";
  }

  if (values.name.trim().length < 3) {
    errors.name = "Major name must have minimum 3 characters";
  }

  if (Object.keys(errors).length > 0) {
    throw errors;
  }
};

export default addMajorValidator;
